module.exports = __webpack_public_path__ + "static/media/17478638222_433693ba83_o (1) - Copie.1d1f4036.jpg";